/** Покупки заглушки. */
import type { PlayerState } from "../api";
import { starPrices } from "../monetization";

export function samplePaidFields(): Pick<
  PlayerState,
  "vip" | "retryLock" | "revive" | "revivePicks" | "starter" | "prices"
> {
  return {
    vip: { active: false, until: null },
    retryLock: null,
    revive: null,
    revivePicks: null,
    starter: null,
    prices: starPrices(false),
  };
}
